import { AdminForm } from "../components";
import { Button } from "app/components";
import SettingsSection from "../settings/SettingsSection";
import { apiRequest } from "app/utils/apiRequests";
import { get } from "lodash";
import { rApp } from "app/utils/recoil";
import { successNotification } from "app/utils/Notification";
import { useRecoilState } from "recoil";
import { useState } from "react";

const EditProfileSettings = () => {
  const [app, setApp] = useRecoilState(rApp);
  const [changes, setChanges] = useState(false);
  const enableProfileEditing = get(app, "enable_edit_profile", false);
  const enabledUsersSheetEditProfileFields = get(
    app,
    "users_sheet_edit_profile_fields",
    ""
  );

  const save = () => {
    setChanges(false);
    apiRequest.post("/app_settings/", {
      enable_edit_profile: enableProfileEditing,
      users_sheet_edit_profile_fields: enabledUsersSheetEditProfileFields,
    });
    successNotification("Saved");
  };

  return (
    <SettingsSection
      settingsCategory="User Settings"
      title="Edit Profile"
      description="Allow users to edit their own profile information"
    >
      <AdminForm
        sectionPadding="0px"
        labelStyle={"headingMd"}
        fields={[
          {
            id: "enable_edit_profile",
            key: "enable_edit_profile",
            label: "Enable Profile Editing",
            description:
              "Enable an auto-generated 'Edit Profile' page for users to edit their own profiles, accessible from the dropdown menu in the app navigation.",
            width: "100%",
            componentId: "Switch",
            defaultValue: false,
            value: enableProfileEditing,
          },
          {
            id: "users_sheet_edit_profile_fields",
            key: "users_sheet_edit_profile_fields",
            label: "Enabled Custom Users Table Fields",
            description:
              "If you want to limit the fields from your Custom Users Table that users can see in the Edit Profile page, enter them in a comma-separated format here, like 'Team,Role,etc'. If left blank, all fields will be shown.",
            width: "100%",
            componentId: "Input",
            defaultValue: "",
            value: enabledUsersSheetEditProfileFields,
          },
        ]}
        onChange={(k, v) => {
          setChanges(true);
          setApp({
            [k]: v,
          });
        }}
      />
      {changes && (
        <Button
          data={{
            margin: "20px 0 0 0",
            text: "Save",
            onClick: save,
          }}
        />
      )}
    </SettingsSection>
  );
};

export default EditProfileSettings;
